import {WelcomePageVo} from '../../common/shared/api/gateway/welcome/WelcomePageVo.interface';
import {WelcomeInfo} from '../generated/types';
import {createWelcomeButtonInfo} from './WelcomeButtonInfo';

export function createWelcomeInfo({
  welcome_message,
  welcome_cash,
  welcome_buttons,
  user_nickname,
}: WelcomePageVo): WelcomeInfo {
  return {
    welcomeMessage: welcome_message,
    welcomeCash: welcome_cash,
    welcomeButtons: welcome_buttons.map(createWelcomeButtonInfo),
    userNickname: user_nickname,
  };
}
